import { requestPath, TRACE_ID_PATTERN, type ISupportNetworkEntry } from '@srm/screen-sharing/light';

/** Последние запросы `$api` для пакета диагностики (§43.2): кольцо пишется всегда — проблема обычно была до обращения. */
export const SUPPORT_NETWORK_LIMIT = 50;

const entries: ISupportNetworkEntry[] = [];

/** Начало запроса: метка в конфиге axios ставится перехватчиком запроса. */
export interface ISupportRequestStart {
    at: string;
    /** `performance.now()` старта. */
    t: number;
}

export const supportRequestStart = (): ISupportRequestStart => ({ at: new Date().toISOString(), t: performance.now() });

export interface ISupportRequestOutcome {
    method?: string;
    url?: string;
    start?: ISupportRequestStart;
    status?: number;
    traceId?: string;
    /** `content-length` ответа. */
    length?: unknown;
    aborted?: boolean;
}

/** Итог запроса — в кольцо: путь без параметров и хоста, без тел; без метки старта (отказ до отправки) — не пишется. */
export function recordSupportRequest({ method, url, start, status, traceId, length, aborted }: ISupportRequestOutcome) {
    const path = requestPath(url);
    if (!start || !path) return;
    const bytes = typeof length === 'string' || typeof length === 'number' ? Number(length) : NaN;
    entries.push({
        at: start.at,
        method: (method ?? 'get').toUpperCase(),
        path,
        ...(status ? { status } : {}),
        durationMs: Math.max(0, Math.round(performance.now() - start.t)),
        ...(traceId && TRACE_ID_PATTERN.test(traceId) ? { traceId } : {}),
        ...(Number.isSafeInteger(bytes) && bytes >= 0 ? { bytes } : {}),
        ...(aborted ? { aborted: true } : {}),
    });
    if (entries.length > SUPPORT_NETWORK_LIMIT) entries.splice(0, entries.length - SUPPORT_NETWORK_LIMIT);
}

export const recentSupportRequests = (): ISupportNetworkEntry[] => entries.slice();

/** Выход и смена пользователя: запросы прежней учётки следующему не достаются. */
export const clearSupportRequests = () => {
    entries.length = 0;
};
